/* eslint-disable */
import sidebarClose from './Actions/SidebarClose.action';
import sidebarOpen from './Actions/SidebarOpen.action';
import sidebarRightClose from './Actions/SidebarRightClose.action';
import sidebarRightOpen from './Actions/SidebarRightOpen.action';
import sidebarRightToggle from './Actions/SidebarRightToggle.action';
import sidebarToggle from './Actions/SidebarToggle.action';

const sidebarActionCreators = {
  sidebarClose,
  sidebarOpen,
  sidebarRightClose,
  sidebarRightOpen,
  sidebarRightToggle,
  sidebarToggle,
};

export default sidebarActionCreators;
